import React from 'react'
import './ColorChangingText.styles.scss'

const ColorChangingText = () => {
    return (
        <>
            <div className="text-effect-container">
                <h2 className="title">
                    <span className="title-word title-word-1">20%</span>
                    <span className="title-word title-word-2">off</span>
                    <span className="title-word title-word-3">storewide</span>
                    <span className="title-word title-word-4">now</span>
                </h2>
            </div>
        </>
    )
}

export default ColorChangingText
